import { useState, useCallback } from "react";

const usePasswordGenerator = (options = {}) => {
  const {
    length = 12,
    includeNumbers = true,
    includeSymbols = true,
    includeUppercase = true,
    includeLowercase = true,
  } = options;

  const [password, setPassword] = useState("");

  const generatePassword = useCallback(() => {
    let lowerChars = "abcdefghijklmnopqrstuvwxyz";
    let upperChars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    let numberChars = "0123456789";
    let symbolChars = "!@#$%^&*()-_=+[]{}|;:'\",.<>?/";

    let characters = "";
    if (includeLowercase) characters += lowerChars;
    if (includeUppercase) characters += upperChars;
    if (includeNumbers) characters += numberChars;
    if (includeSymbols) characters += symbolChars;

    if (!characters) return "";

    let newPassword = "";

    // Ensure at least one number if required
    if (includeNumbers) {
      newPassword += numberChars.charAt(
        Math.floor(Math.random() * numberChars.length)
      );
    }

    // Fill the rest of the password
    for (let i = newPassword.length; i < length; i++) {
      newPassword += characters.charAt(
        Math.floor(Math.random() * characters.length)
      );
    }

    // Shuffle the password to mix characters
    newPassword = newPassword
      .split("")
      .sort(() => 0.5 - Math.random())
      .join("");

    setPassword(newPassword);
    return newPassword;
  }, [
    length,
    includeNumbers,
    includeSymbols,
    includeUppercase,
    includeLowercase,
  ]);

  return { password, generatePassword };
};

export default usePasswordGenerator;
